<ng-container *ngIf="loading">
    <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12" [nzLg]="18" class="desktop:h-[380px]">
            <nz-card aria-label="Line Chart Card">
                <nz-page-header class="px-0 py-2">
                    <nz-page-header-content>
                        <nz-row class="justify-between items-center flex-wrap gap-2">
                            <ng-container *ngIf="viewOptions.radio?.show">
                                <nz-radio-group [(ngModel)]="filterType" (ngModelChange)="onFilterTypeChange($event)"
                                    nzButtonStyle="outline">
                                    <ng-container *ngFor="let filter of rangeFilters">
                                        <label nz-radio-button [nzValue]="filter?.value"
                                            class="font-semibold">{{filter?.label}}</label>
                                    </ng-container>
                                </nz-radio-group>
                            </ng-container>
                            <nz-range-picker [nzDisabledDate]="disableDates" nzPlacement="bottomRight"
                                [(ngModel)]="dateRange" [nzDisabled]="viewOptions.dateRange?.disable"
                                (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
                        </nz-row>
                    </nz-page-header-content>
                </nz-page-header>
                <nz-spin [nzSpinning]="true" [nzTip]="'Loading temperature graph...'"
                    class="desktop:h-[270px]"></nz-spin>
            </nz-card>
        </nz-col>
        <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12" [nzLg]="6" class="desktop:h-[400px] h-auto">
            <nz-card nzTitle="Last Reading" aria-label="Last Reading Card">
                <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 8 }"></nz-skeleton>
            </nz-card>
        </nz-col>
    </nz-row>
</ng-container>

<ng-container *ngIf="!loading">
    <ng-container *ngIf="graphData.length > 0; else noGraphDataBlock">
        <nz-row *ngFor="let item of graphData; let i = index; trackBy: feUtil.trackByFn" [nzGutter]="[16, 16]"
            class="pb-3.5">
            <ng-container *ngIf="viewOptions.view?.includes('graph')">
                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="16" [nzLg]="viewOptions.view?.includes('readings') ? 18 : 24"
                    class="desktop:h-[500px]">
                    <nz-card aria-label="Line Chart Card">
                        <nz-page-header class="px-0 py-2">
                            <nz-page-header-title *ngIf="viewOptions.showTitle ?? true" class="text-base">{{ item.matrixType | titlecase
                                }}</nz-page-header-title>
                            <nz-page-header-content>
                                <nz-row class="justify-between items-center flex-wrap gap-2">
                                    <ng-container *ngIf="viewOptions.radio?.show">
                                        <nz-col>
                                            <nz-radio-group [(ngModel)]="filterType"
                                                (ngModelChange)="onFilterTypeChange($event)" nzButtonStyle="outline">
                                                <ng-container *ngFor="let filter of rangeFilters">
                                                    <label nz-radio-button [nzValue]="filter?.value"
                                                        class="font-semibold">{{filter?.label}}</label>
                                                </ng-container>
                                            </nz-radio-group>
                                        </nz-col>
                                    </ng-container>
                                    <ng-container *ngIf="viewOptions.dateRange?.show">
                                        <nz-col>
                                            <nz-range-picker [nzDisabledDate]="disableDates" nzPlacement="bottomRight"
                                                [(ngModel)]="dateRange" [nzDisabled]="viewOptions.dateRange?.disable"
                                                (ngModelChange)="onDateRangeChange($event)">
                                            </nz-range-picker>
                                        </nz-col>
                                    </ng-container>
                                </nz-row>
                            </nz-page-header-content>
                        </nz-page-header>

                        <apx-chart [series]="item?.chartOptions?.series" [chart]="chart" [dataLabels]="dataLabels"
                            [markers]="markers" [fill]="fill" [yaxis]="yaxis" [xaxis]="xaxis" [tooltip]="tooltip"
                            [autoUpdateSeries]="true" [annotations]="item?.chartOptions?.annotations">
                        </apx-chart>
                    </nz-card>
                </nz-col>
            </ng-container>

            <ng-container *ngIf="viewOptions.view?.includes('readings')">
                <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="6" class="desktop:h-[500px] h-auto">
                    <nz-card nzTitle="Last Reading" aria-label="Last Reading Card">
                        <cdk-virtual-scroll-viewport itemSize="30" class="desktop:h-[400px] h-[500px] overflow-auto"
                            aria-label="Last Reading List">
                            <ul nz-list nzSize="small" aria-label="Last Reading List">
                                <li style="padding: 8px 0;" nz-list-item
                                    *cdkVirtualFor="let reading of item['lastReadingData'][item.chartOptions?.series[0]?.name]; trackBy: feUtil.trackByFn">
                                    <div class="flex justify-between w-full text-xs mr-2"
                                        [ngClass]="reading?.status === 'normal' ? 'text-black' : (feUtil.getSeverityColor(reading?.status))">
                                        <div class="flex">
                                            <span class="flex items-center gap-2 mr-2">
                                                <i nz-icon nzType="calendar" nzTheme="outline"></i>
                                                {{ reading?.datetime | gDate: 'MMM d, y'}}
                                            </span>
                                            <span class="flex items-center gap-2">
                                                <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                                                {{ reading?.datetime | gDate: 'HH:mm:ss'}}
                                            </span>
                                        </div>
                                        <span class="flex items-center gap-2">
                                            {{ feUtil.getFormattedTemp(reading?.value,
                                            item?.matrixType?.toLowerCase())}}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </cdk-virtual-scroll-viewport>
                    </nz-card>
                </nz-col>
            </ng-container>
        </nz-row>
    </ng-container>

    <ng-template #noGraphDataBlock>
        <nz-row [nzGutter]="[16, 16]" class="items-start pb-2.5">
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="18" [nzLg]="viewOptions.view?.includes('readings') ? 18 : 24" *ngIf="viewOptions.view?.includes('graph')">
                <nz-card aria-label="Line Chart Card">
                    <nz-page-header class="px-0 py-2">
                        <nz-page-header-content>
                            <nz-row class="justify-between items-center flex-wrap gap-2">
                                <ng-container *ngIf="viewOptions.radio?.show">
                                    <nz-col>
                                        <nz-radio-group [(ngModel)]="filterType" (ngModelChange)="onFilterTypeChange($event)"
                                            nzButtonStyle="outline">
                                            <ng-container *ngFor="let filter of rangeFilters">
                                                <label nz-radio-button [nzValue]="filter?.value"
                                                    class="font-semibold">{{filter?.label}}</label>
                                            </ng-container>
                                        </nz-radio-group>
                                    </nz-col>
                                </ng-container>
                                <ng-container *ngIf="viewOptions.dateRange?.show">
                                    <nz-col>
                                        <nz-range-picker [nzDisabledDate]="disableDates" nzPlacement="bottomRight"
                                            [(ngModel)]="dateRange" [nzDisabled]="viewOptions.dateRange?.disable"
                                            (ngModelChange)="onDateRangeChange($event)">
                                        </nz-range-picker>
                                    </nz-col>
                                </ng-container>
                            </nz-row>
                        </nz-page-header-content>
                    </nz-page-header>
                    <div class="w-full desktop:h-[400px] h-auto flex justify-center items-center">
                        <nz-empty nzNotFoundContent="No graph data found for this trip"></nz-empty>
                    </div>
                </nz-card>
            </nz-col>
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="6" [nzLg]="6" *ngIf="viewOptions.view?.includes('readings')">
                <nz-card class="w-full desktop:h-[500px] h-auto flex justify-center items-center"
                    aria-label="Last Reading Card">
                    <nz-empty nzNotFoundContent="No data found for this trip"></nz-empty>
                </nz-card>
            </nz-col>
        </nz-row>
    </ng-template>
</ng-container>